import Vue from 'vue';

if (window.hwerrVue) {
  Vue.config.errorHandler = window.hwerrVue;
}

import { initBiPoint } from '../../resource/plugins/biPoint/index';

import AnalyzePoint, {
  routerEnter
} from '../../resource/plugins/AnalyzePoint/index';

import App from '../../officialWebStoreApp.vue';
import router from '../rooters/officialWebStore';
import store from '../stores/officialWebStore';
import commonComponents from '@components/officialWebStore/common/commonComponents';
import clickThrottling from '../../resource/plugins/clickThrottling';
import 'swiper/css/swiper.css';
import { handleStoreDefaultCid } from '@utiles/storeHandleCid';
import bridge from '@utiles/bridge';
import globalConfig from '@utiles/officialStore/globalConfig';
import '@plugins/replaceAllPolyfills';

// ！！！注意：重定向逻辑要在initBiPoint之前，否则会导致【会话开始】打点打在旧页面.
// 重定向逻辑 start
const gameId =
  globalConfig.getHrefParam('gameId') ||
  globalConfig.getHrefParam('gameID') ||
  globalConfig.getHrefParam('game_id') ||
  '';
// 2024.6.12 判断Puzzles & Chaos主子游戏跳转到v1礼包版第三方支付页
if ([285, 354, 355].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.pathname = currentUrl.pathname.replace(
    'officialWebStore.html',
    'officialStore.html'
  );
  window.location.href = currentUrl.href;
}
// 2024.11.13 欧美mu跳转到v3第三方支付页
if ([390].includes(+gameId)) {
  const currentUrl = new URL(window.location);
  currentUrl.pathname = currentUrl.pathname.replace(
    'officialWebStore.html',
    'officialTopup.html'
  );
  // 智轩：跳转到v3储值页，需要强制竖屏，webview调用sdk方法打开webview
  if (bridge.runInsdk()) {
    bridge.callSdkMethod('openWebView', {
      url: currentUrl.href,
      loginDir: 0,
      appendParams: 1,
      pageOrientation: 1
    });
  } else {
    window.location.href = currentUrl.href;
  }
}
// 重定向逻辑 end
handleStoreDefaultCid();

// 如果是重定向游戏，不初始化bi
if (![285, 354, 355, 390].includes(+gameId)) {
  initBiPoint({ dataLayerName: 'webstorev2DataLayer' });
}
Vue.use(AnalyzePoint('global-pay', 'officialWebStore', true));
// 设置点击节流.
Vue.use(clickThrottling);
clickThrottling.setThrottlingTime(800);

Vue.config.productionTip = true;
Vue.use(commonComponents);

router.beforeEach((to, _from, next) => {
  routerEnter(to.name);
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#officialWebStore');
